import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { loginUUID } from 'src/app/app.constants';
import { environment } from '../../../environments/environment';
import { ClientRegister } from '../../models/client/client-register.model';
import { ForgotConfirmPassword } from '../../models/client/forgot-confirm-password.model';
import { PushToken } from './../../models/client/push-token';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  protected resourceUrl = `${environment.api_url}/clients`;
  constructor(protected http: HttpClient) {}

  register(client: ClientRegister): Observable<HttpResponse<null>> {
    return this.http.post<null>(`${this.resourceUrl}/register`, client, {
      observe: 'response'
    });
  }

  registerSocial(client: ClientRegister): Observable<HttpResponse<null>> {
    return this.http.post<null>(`${this.resourceUrl}/register-social`, client, {
      observe: 'response'
    });
  }

  forgotPassword(email: string): Observable<HttpResponse<null>> {
    return this.http.post<null>(
      `${this.resourceUrl}/forgot-password`,
      { email },
      {
        observe: 'response'
      }
    );
  }

  forgotConfirmPassword(
    forgotConfirmPassword: ForgotConfirmPassword,
    token: string
  ): Observable<HttpResponse<null>> {
    return this.http.post<null>(
      `${this.resourceUrl}/forgot-password/?token=${token}`,
      forgotConfirmPassword,
      {
        observe: 'response'
      }
    );
  }

  pushToken(): Observable<HttpResponse<null>> {
    const body: PushToken = {
      devicePlatform: 'WEB',
      identifier: localStorage.getItem(loginUUID),
      name: navigator.userAgent
    };
    return this.http.post<null>(`${this.resourceUrl}/push-token`, body, {
      observe: 'response'
    });
  }

  registrationValidate(token: string): Observable<HttpResponse<null>> {
    return this.http.post<null>(
      `${this.resourceUrl}/register-validate/${token}`,
      null,
      {
        observe: 'response'
      }
    );
  }

  resendValidate(email: string): Observable<HttpResponse<null>> {
    return this.http.post<null>(
      `${this.resourceUrl}/register-validate/resend`,
      { email },
      {
        observe: 'response'
      }
    );
  }
}
